<template>
    <ul class="nav nav-tabs full" role="tablist">
        <template v-for="(tab, index) in tabs">
            <li :key="`navtab-${index}`" :class="{ active: activeSubtab == tab.link }" role="presentation" @click="changeActiveSubtab(tab.link)">
                <a :aria-controls="tab.link" :class="tab.class" data-toggle="tab" :href="`#${tab.link}`" role="tab" aria-expanded="false">
                    {{ tab.name }}
                </a>
            </li>
        </template>
    </ul>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "NavTabs",
    props: {
        tabs: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapState({
            activeSubtab: state => state.Step4.activeSubtabs[state.Step4.activeTab]
        })
    },
    methods: {
        ...mapActions([
            "changeActiveSubtab"
        ])
    }
}
</script>
